import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Select, Form } from "antd";
import { useProjectState } from "../../../context/stateContext";
import appActions from "../../../redux/getOrganizationAndRestaurant/actions";
import qrActions from "../../../redux/qr/actions";

const { setSelectedRestaurant } = appActions;
const { Option, OptGroup } = Select;

const { updateQRTable } = qrActions;

const QRManagementModal = () => {
  const { selectedOrganization } = useProjectState();

  const {
    tables,
    showScanner,
    scannedQRTable,
    tableScanStatus,
    originalTouchSaleTables,
  } = useSelector((state) => state.qrReducer);

  const { restaurants, selectedRestaurant, organizations } = useSelector(
    (state) => state.getOrganizationAndRestaurantReducer
  );

  const touchSaleTables = originalTouchSaleTables.filter(
    (u) => tables.filter((t) => t.name === u.name).length === 0
  );

  const dispatch = useDispatch();

  const onRestrauntRecordChange = (value) => {
    scannedQRTable.restaurantId = value;
    scannedQRTable.restaurantName = restaurants.filter(
      (r) => r.id === value
    )[0].name;
    dispatch(updateQRTable(scannedQRTable, tableScanStatus));
    dispatch(setSelectedRestaurant(value));
    window.localStorage.setItem("restaurantId", value);
  };

  const onSelectedTableName = (value, x) => {
    scannedQRTable["name"] = value;
    scannedQRTable["touchSaleTableId"] = parseInt(x.key);
    dispatch(updateQRTable(scannedQRTable));
  };

  const getDifferenceTables = (array1, array2) => {
    return array1.filter((object1) => {
      return !array2.some((object2) => {
        return object1.id === object2.id;
      });
    });
  };

  const usedTables = getDifferenceTables(
    originalTouchSaleTables,
    originalTouchSaleTables.filter(
      (u) => tables.filter((t) => t.name === u.name).length === 0
    )
  );

  const defaultOrganization = organizations.filter(
    (itemInArray) => itemInArray.id === selectedOrganization
  );

  return (
    <div
      style={{
        display:
          showScanner === false &&
          (restaurants?.filter((r) => r.id === scannedQRTable?.restaurantId)[0]
            ?.name ===
            restaurants?.filter((r) => r.id === selectedRestaurant)[0]?.name ||
            tableScanStatus === 2 ||
            tableScanStatus === 0)
            ? "block"
            : "none",
        padding: "10px",
      }}
    >
      {tableScanStatus !== 1 ? (
        <>
          <div className="qr-management-modal-table-information">
            {!defaultOrganization[0]?.multipleRestaurants && (
              <p>
                <strong>Ресторант:</strong>{" "}
                {scannedQRTable?.restaurantId === 0
                  ? restaurants?.filter((r) => r.id === selectedRestaurant)[0]
                      ?.name
                  : scannedQRTable?.restaurantName}
              </p>
            )}
            <p>
              <strong>QR код:</strong> {scannedQRTable?.identifier}
            </p>
          </div>
          <Form>
            <Form.Item>
              <Select
                showSearch
                virtual={false}
                disabled={touchSaleTables === undefined}
                className="qr-management-modal-select ant-select-selection-search-input"
                placeholder="Маса"
                onChange={onSelectedTableName}
                value={scannedQRTable?.name}
                placement="topLeft"
              >
                <OptGroup label="Свободни маси">
                  {touchSaleTables.map((table, index) => (
                    <Option
                      key={`${table.id}-${index}`}
                      value={table.name}
                      className="qr-management-modal-option"
                    >
                      {table.name}
                    </Option>
                  ))}
                </OptGroup>
                <OptGroup label="Закачени маси">
                  {usedTables.map((table, index) => (
                    <React.Fragment key={index}>
                      <Option
                        key={`${table.id}-${index}`}
                        value={table.name}
                        className="qr-management-modal-option"
                      >
                        <p className="qr-management-modal-attached-table">
                          {table.name}
                        </p>
                      </Option>
                    </React.Fragment>
                  ))}
                </OptGroup>
              </Select>
              {/* </div> */}
            </Form.Item>
            {defaultOrganization[0]?.multipleRestaurants && (
              <Form.Item>
                <p className="qr-management-modal-form-item">Ресторант</p>
                <Select
                  virtual={false}
                  placeholder="Изберете ресторант"
                  value={
                    scannedQRTable?.restaurantId === 0
                      ? restaurants?.filter(
                          (r) => r.id === selectedRestaurant
                        )[0]?.id
                      : scannedQRTable?.restaurantId
                  }
                  onChange={(e) => onRestrauntRecordChange(e)}
                  className="qr-management-modal-select"
                >
                  {restaurants?.map((restaurant, index) => (
                    <Option
                      key={`${restaurant.id}-${index}`}
                      value={restaurant.id}
                      className="qr-management-modal-option"
                    >
                      {restaurant.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            )}
          </Form>
        </>
      ) : (
        <div
          style={{
            display: tableScanStatus !== 1 ? "none" : "block",
          }}
          className="qr-management-modal-existing-table-container"
        >
          <p>
            Този код е свързан с маса:{" "}
            <strong style={{ color: "#1677ff" }}>{scannedQRTable?.name}</strong>{" "}
            в ресторант{" "}
            <strong style={{ color: "#1677ff" }}>
              {
                restaurants?.filter(
                  (r) =>
                    parseInt(r.id) === parseInt(scannedQRTable?.restaurantId)
                )[0]?.name
              }
            </strong>
            .
            <br />
            <br />
            <strong>Желаете ли да го преместите?</strong>
          </p>
        </div>
      )}
    </div>
  );
};

export default QRManagementModal;
